import { createContext, useState } from "react";

export const PumpContext = createContext();

export const PumpProvider = ({ children }) => {

  const [pumpData, setPumpData] = useState({});

  const updatePump = (tag, updates) => {
    setPumpData(prev => ({
      ...prev,
      [tag]: {
        ...prev[tag],
        ...updates
      }
    }));
  };

  return (
    <PumpContext.Provider value={{ pumpData, updatePump }}>
      {children}
    </PumpContext.Provider>
  );
};